import Image from "@/models/Image";
import store from "@/store";
import getCoordinateCoverImage from "@/helpers/getCoordinateCoverImage";
import getTextFromHtmlString from "@/helpers/getTextFromHtmlString";

export class Coordinate {

  constructor(data) {
    this.id = data.id
    this.hasManualOrder = data.images.some((image) => !!image.order)
    this.allImages = data.images
      .map((image) => new Image(image, data, this.hasManualOrder))
      .sort((a, b) => a.sortValue - b.sortValue)
    this.lat = data.lat
    this.lng = data.lng
    this.num = data.num ? data.num + '' : ''
    this.region = data.region
    this.street = data.street

    const streetNameText = getTextFromHtmlString(this.street?.name);
    const houseNumberText = getTextFromHtmlString(this.num);
    this.streetLabel = `${this.street?.name || ""} ${this.num || ""}`;
    this.streetLabelText = `${streetNameText} ${houseNumberText}`;
    this.streetNameLowerCase = streetNameText.toLowerCase();
    this.houseNumberLowerCase = houseNumberText.toLowerCase();
    this.houseNumberNumeric = (number => isNaN(number) ? this.extractNumericStart() : number)(this.toNumber());

    this.coverImage = getCoordinateCoverImage(this)
    this.sortValue = this.coverImage?.sortValue || Infinity
  }

  toNumber() {
    return this.num && this.num.length ? Number(this.num) : NaN;
  }

  startsWithNumber() {
    return !!(this.num && this.num.length && this.num.match(/^\d+.*/));
  }

  extractNumericStart() {
    return this.startsWithNumber() ? Number(this.num.split(/\D/, 2)[0]) : -Infinity;
  }

  get images() {
    if (store.state.Filters.beforeYear) {
      return this.allImages.filter(({ sortValue }) => {
        return Math.trunc(sortValue) <= store.state.Filters.beforeYear
      })
    } else {
      return this.allImages
    }
  }

  get allImagesYears() {
    return this.allImages
      .map(({ fromYear, toYear }) => [fromYear, toYear])
      .flat()
      .filter((year) => year !== null && year !== 0)
  }
  get imagesYears() {
    return this.images
      .map(({ fromYear, toYear }) => [fromYear, toYear])
      .flat()
      .filter((year) => year !== null && year !== 0)
  }

  get fromYear() {
    return Math.min(...this.imagesYears)
  }

  get toYear() {
    return Math.max(...this.imagesYears)
  }

}

export default Coordinate
